import React from 'react';
import { Box, Copy, Icon, IconWrapper } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import themeStyles from './Schedule.style';

const ScheduleContainer = themeStyles.apply(Box, 'ScheduleContainer');
const ScheduleWrapper = themeStyles.apply(Box, 'ScheduleWrapper');
const ScheduleItem = themeStyles.apply(Box, 'ScheduleItem');
const ScheduleItemTitle = themeStyles.apply(Copy, 'ScheduleItemTitle');
const ScheduleItemTime = themeStyles.apply(Copy, 'ScheduleItemTime');

const Schedule = ({ items, dataTestId, isDealerDetailSchedule }) => {
  const { t } = useTranslation();
  const allClosed = items.every(item => item?.time === t('Sub-apps.Dealers.closedLabel'));

  if (!items.length || allClosed) {
    return null;
  }
  return (
    <ScheduleContainer data-testid={dataTestId}>
      <IconWrapper data-testid="cy-clock-icon">
        <Icon name="clock" />
      </IconWrapper>
      <ScheduleWrapper>
        {items.map(item => {
          if (!item || !item.title || !item.time) {
            return null;
          }

          return (
            <ScheduleItem data-testid="cy-schedule-item" key={item.title}>
              <ScheduleItemTitle
                isBold={!isDealerDetailSchedule || (isDealerDetailSchedule && item.isCurrentDayOfWeek)}
                data-testid="cy-schedule-title"
                size="small"
              >
                {item.title}
              </ScheduleItemTitle>
              <ScheduleItemTime
                data-testid="cy-schedule-time"
                size="small"
                isBold={isDealerDetailSchedule && item.isCurrentDayOfWeek}
              >
                {item.time}
              </ScheduleItemTime>
            </ScheduleItem>
          );
        })}
      </ScheduleWrapper>
    </ScheduleContainer>
  );
};

Schedule.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string,
      title: PropTypes.string,
      isCurrentDayOfWeek: PropTypes.bool,
    }),
  ),
  dataTestId: PropTypes.string,
  isDealerDetailSchedule: PropTypes.bool,
};

Schedule.defaultProps = {
  items: [],
  dataTestId: '',
  isDealerDetailSchedule: false,
};

export default Schedule;
